import { render, staticRenderFns } from "./ReportingPreferencesStep.vue?vue&type=template&id=2f0b5bc2&scoped=true"
import script from "./ReportingPreferencesStep.vue?vue&type=script&lang=js"
export * from "./ReportingPreferencesStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0b5bc2",
  null
  
)

export default component.exports